import { useEffect } from 'react'
import useSWR from 'swr'
import { useProductPackagesStore } from '@/stores/product-packages-store'

export const PRODUCT_PACKAGES_URL = '/product-packages'

/** 无 UI：登录后拉取下级 App 别名写入全局 store；mutateRequest 该 URL 可触发重新拉取 */
const ProductPackagesLoader = () => {
  const { data } = useSWR([PRODUCT_PACKAGES_URL])
  const setItems = useProductPackagesStore((state) => state.setItems)

  useEffect(() => {
    if (Array.isArray(data)) setItems(data)
  }, [data, setItems])

  return null
}

export default ProductPackagesLoader
